<template>
  <v-table
    v-resize="onResize"
    density="compact"
    fixed-header
    :style="{ maxHeight: maxHeight || undefined }"
    :height="maxHeight ? '' : windowSize.y - 64"
  >
    <thead>
      <tr>
        <th class="item-expansion"></th>
        <th class="item-floc">Functional Location</th>
        <th class="item-floc-desc">Func. Loc. Description</th>
        <th class="item-is-asset">Is Asset</th>
        <th class="item-asset-class">Asset Class</th>
        <th class="item-actions"></th>
      </tr>
    </thead>
    <tbody>
      <FunctionalLocationRow
        v-for="treeItem in treeItems"
        :key="treeItem.item.id"
        :tree-item="treeItem"
        :depth="0"
        @expand="expand"
        @collapse="collapse"
        @view="$emit('view', $event)"
      />
    </tbody>
  </v-table>
</template>

<script lang="ts" setup>
import { FunctionalLocation } from "@/classes";
import { setupApiQueue } from "@/components/base/api-queue";
import { TreeItem } from "./tree";
import FunctionalLocationRow from "./FunctionalLocationRow.vue";
import { setupWindowSize } from "@/components/base/tables/window";

const props = defineProps<{
  treeItems: TreeItem<FunctionalLocation>[];
  maxHeight?: string;
}>();

const emit = defineEmits<{
  (e: "view", treeItem: TreeItem<FunctionalLocation>): void;
  (e: "remove", treeItem: TreeItem<FunctionalLocation>): void;
}>();

const { queueApiAction, loading } = setupApiQueue();

const getTreeChildren = async (item: TreeItem<FunctionalLocation>) => {
  queueApiAction(async () => {
    const parentId = item.item.id;
    const flocs = await FunctionalLocation.getTreeChildren({
      parent_id: parentId,
    });
    const children = flocs.map((floc) => {
      return {
        item: floc,
        expanded: false,
        children: null,
      } as TreeItem<FunctionalLocation>;
    });
    item.children = children;
  });
};

const expand = async (item: TreeItem<FunctionalLocation>) => {
  item.expanded = true;
  if (item.children === null) {
    item.children = getTreeChildren(item);
  }
};

const collapse = async (item: TreeItem<FunctionalLocation>) => {
  item.expanded = false;
};

const { windowSize, onResize } = setupWindowSize();

const findItem = (
  parent: TreeItem<FunctionalLocation> | null,
  items: TreeItem<FunctionalLocation>[],
  id: string,
): {
  parent: TreeItem<FunctionalLocation> | null;
  item: TreeItem<FunctionalLocation> | null;
} => {
  for (const item of items) {
    if (item.item.id === id) {
      return { parent, item };
    }
  }
  for (const item of items) {
    if (Array.isArray(item.children)) {
      const found = findItem(item, item.children, id);
      if (found) {
        return found;
      }
    }
  }
  return { parent: null, item: null };
};

const refresh = async (id: string | null) => {
  if (id !== null) {
    const { parent, item } = findItem(null, props.treeItems, id);
    if (item) {
      const childrenCount = item.item.metrics.children_count;
      await item.item.refresh();
      item.item.metrics.children_count = childrenCount;

      if (item.item.hide_from_tree_top) {
        if (parent) {
          //if (Array.isArray(parent.children)) {
          //  parent.children = parent.children.filter((c) => c !== item);
          //}
        } else {
          emit("remove", item);
        }
      }
    }
  }
};

defineExpose({ refresh });
</script>

<style lang="scss" scoped>
@use "./tree";
</style>
